export default "__VITE_ASSET__67xUIbFC__"